import Moment from "moment";

export const stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    const stableCmp = (a, b) => {
        let order = cmp(a[0], b[0]);
        if (order != 0) return order;
        return a[1] - b[1];
    };
    stabilizedThis.sort(stableCmp);
    return stabilizedThis.map(el => el[0]);
};

export const getSorting = (order, orderBy) =>
    order === "desc" ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);

export const desc = (a, b, orderBy) => {
    if (b[orderBy] != null && a[orderBy] != null) {
        if (isNaN(b[orderBy]) && isNaN(a[orderBy])) {
            const HHmmssRegex = /^(?:(?:([01]?d|2[0-3]):)?([0-5]?d):)?([0-5]?d)$/;
            if (b[orderBy].match(HHmmssRegex) && a[orderBy].match(HHmmssRegex)) {
                return Moment(a[orderBy], "HH:mm:ss").isAfter(Moment(b[orderBy], " HH:mm:ss")) ? -1 : 1;
            }
            if (b[orderBy].toString().toLowerCase() < a[orderBy].toString().toLowerCase()) return -1;
            else return 1;
        } else {
            if (b[orderBy] < a[orderBy]) return -1;
            if (b[orderBy] > a[orderBy]) return 1;
        }
    } else if (b[orderBy] == null && a[orderBy] != null) {
        return -1;
    } else if (b[orderBy] != null && a[orderBy] == null) {
        return 1;
    }

    return 0;
};
//columns parameters receives the columns that are going to be filtered depending on the table
export const filterData = (data, filterString, columns) => {
    let filteredRows = [];
    let filteredRow;
    let columnsToFilter = {};

    if (filterString == "") {
        return data;
    }

    data.forEach(row => {
        filteredRow = false;
        if (!columns) {
            columnsToFilter = row;
        } else {
            for (const column of columns) {
                if (row[column]) columnsToFilter[column] = row[column];
            }
        }
        Object.values(columnsToFilter).filter(entry => {
            if (entry !== null) {
                if (typeof entry !== String) entry = entry.toString();
                if (!filteredRow && entry.toLowerCase().includes(filterString.toLowerCase())) {
                    filteredRow = true;
                    filteredRows.push(row);
                }
            }
        });
    });
    return filteredRows;
};
